'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultStyles = {
  root: {
    position: 'relative',
    paddingBottom: '0px'
  },
  input: {
    display: 'inline-block',
    width: '100%',
    padding: '10px'
  },
  autocompleteContainer: {
    position: 'absolute',
    top: '100%',
    backgroundColor: 'white',
    border: '1px solid #555555',
    width: '100%'
  },
  autocompleteItem: {
    backgroundColor: '#ffffff',
    padding: '10px',
    color: '#555555',
    cursor: 'pointer'
  },
  autocompleteItemActive: {
    backgroundColor: '#fafafa'
  },
  googleLogoContainer: {
    textAlign: 'right',
    padding: '1px',
    backgroundColor: '#fafafa'
  },
  googleLogoImage: {
    width: 150
  }
};

exports.default = defaultStyles;


//////////////////
// WEBPACK FOOTER
// ./~/react-places-autocomplete/dist/defaultStyles.js
// module id = 659
// module chunks = 0